class HeroSlidergrid extends HTMLElement {
  constructor() {
    super();

    if (window.Shopify?.designMode) {
      window.addEventListener('shopify:section:load', e => {
        this.mountSlider();
      });
    }

    this.mountSlider();

    window.addEventListener('shopify:block:select', e => {
      const selectedSlideIndex = +e.target.dataset.index;
      this.slider.slideTo(selectedSlideIndex, 600);
    });
  }

  mountSlider() {
    const autoplayOptions = {
      delay: this.dataset.autoplayInterval
    };

    this.slider = new Swiper(this, {      
      rewind: true,
      slidesPerView: 1,
      speed: 600,
      followFinger: false,
      navigation: {
        nextEl: '.swiper-button--next',
        prevEl: '.swiper-button--prev'
      },
      autoplay:true,
    });
  }
}
  customElements.define("card-product-grid-slider", HeroSlidergrid);
